export default [
  { key: 'V', value: 'VISA' },
  { key: 'M', value: 'MASTERCARD' },
  { key: 'AX', value: 'AMERICAN EXPRESS' },
  { key: 'NO', value: 'DISCOVER' },
  { key: 'D', value: 'DEBIT' },
  { key: 'C1', value: 'JBC' },
  { key: 'P', value: 'INTERAC' },
];
